module.exports = __webpack_public_path__ + "img/0112.406028d9.png";